// import imageCompression from 'browser-image-compression';
// import { RcFile } from "antd/es/upload";
import { UploadFile } from "antd";

const onHandleCompressImages = async (originalFileList: UploadFile<any>[]) => {
    const compressedFileList: UploadFile<any>[] = [];
    await Promise.all(
        originalFileList.map(async (file: any) => {
            // const rawFile = file[0]?.originFileObj as File;
            // if (
            //     rawFile &&
            //     rawFile?.size > 500000 &&
            //     ['.jpg', '.jpeg', '.png', '.heic', '.heif', '.hevc'].some((ext) =>
            //         rawFile?.name?.toLowerCase()?.endsWith(ext)
            //     )
            // ) {
            //     try {
            //         const compressedBlob = await imageCompression(rawFile, {
            //             maxSizeMB: 0.5,
            //             maxWidthOrHeight: 3000,
            //             useWebWorker: true,
            //         });

            //         const compressedFile: RcFile = new File(
            //             [compressedBlob],
            //             rawFile.name,
            //             {
            //                 type: compressedBlob?.type,
            //                 lastModified: rawFile?.lastModified,
            //             }
            //         ) as RcFile;

            //         (compressedFile as any).uid = file?.uid;
            //         compressedFileList.push(compressedFile);
            //     } catch (err) {
            //         console.error("Compression failed", err);
            //     }
            // } else {
                compressedFileList.push(file[0]?.originFileObj);
            // }
        })
    );
    return compressedFileList;
};

export default onHandleCompressImages;